import { render, staticRenderFns } from "./CommercialTag.vue?vue&type=template&id=5d2c65b2"
import script from "./CommercialTag.vue?vue&type=script&lang=ts"
export * from "./CommercialTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports